import Vue from 'vue'
import { S, G, M, A } from './types'
import { Getters, Mutations, Actions } from 'vuex'
import message from '../message'

/* -------------------------------------------------------------------------- */

const state = (): S => ({
  visible: false,
  errorResponse: {},
  errorMessages: [],
  messages: []
})

/* -------------------------------------------------------------------------- */

const getters: Getters<S, G> = {
  visible: ({ visible }) => visible,
  messages: ({ messages }) => messages,
  errorMessages: ({ errorResponse, errorMessages }) => {
    console.log('errorResponse', errorResponse, Object.entries(errorResponse))
    const responses = Object.entries(errorResponse).map(val => String(val[1]))
    return [...responses, ...errorMessages]
  }
}

/* -------------------------------------------------------------------------- */

const mutations: Mutations<S, M> = {
  updateVisible: (state, visible) => {
    state.visible = visible
  },
  updateErrorResponse: (state, response) => {
    state.errorResponse = response
  },
  updateErrorMessages: (state, messages) => {
    state.errorMessages = messages
  },
  updateMessages: (state, messages) => {
    state.messages = messages
  }
}

/* -------------------------------------------------------------------------- */

const actions: Actions<S, A, G, M> = {
  show: ({ commit }) => {
    commit('updateVisible', true)
  },
  hide: ({ commit }) => {
    commit('updateErrorResponse', {})
    commit('updateErrorMessages', [])
    commit('updateMessages', [])
    commit('updateVisible', false)
  },
  showErrorResponse: async ({ commit }, response) => {
    commit('updateVisible', true)
    commit('updateErrorResponse', response)
  },
  showErrorMessages: async ({ commit }, messages) => {
    commit('updateVisible', true)
    commit('updateErrorMessages', messages)
  },
  showMessages: async ({ commit }, messages) => {
    commit('updateVisible', true)
    commit('updateMessages', messages)
  }
}

/* -------------------------------------------------------------------------- */

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
